import type { AuthPermissionUser } from '../../services/authPermissions';

const PRODUCT_CATALOG_MANAGEMENT_ROLES = ['ADMIN', 'OPERATIONS'];

export function canManageProductCatalog(user: AuthPermissionUser | null | undefined): boolean {
  return PRODUCT_CATALOG_MANAGEMENT_ROLES.includes(user?.role || '');
}

export function canDeleteProductCatalogItem(user: AuthPermissionUser | null | undefined): boolean {
  return PRODUCT_CATALOG_MANAGEMENT_ROLES.includes(user?.role || '');
}
